import fragranceOfTheMonthPage from './fragranceOfTheMonthPage/rest'


export default {
  fragranceOfTheMonthPage,
}
